<template>
  <div>
    <div class="base-pagination">
      <el-pagination
          v-show="enablePagination"
          :current-page="currentPage + 1"
          :page-size="size"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="prev, pager, next, sizes, total"
          @size-change="onSizeChange"
          @current-change="onCurrentChange" />
    </div>
    <div v-show="showTotalCount"
        class="right pagination__total">
      (総検索結果:{{ totalCount }}件)
    </div>
  </div>
</template>

<style scoped>
.pagination__total {
  font-size: 13px;
  color: rgb(96, 98, 102);
  margin-top: 2px;
  margin-right: 4px;
}
</style>

<script>
export default {
  name: 'BasePagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * paginationを表示するか.
     * @return {Boolean} true の場合、表示する.
     */
    enablePagination () {
      return this.total > 0
    },
    showTotalCount () {
      return this.totalCount !== 0 && this.totalCount !== this.total
    }
  },
  methods: {
    onSizeChange (val) {
      this.$emit('size-change', val)
    },
    onCurrentChange (val) {
      this.$emit('current-change', val - 1)
    }
  }
}
</script>
